export default __webpack_public_path__ + "static/mujeres-2d4b00ea5b2c6e5ea6998afabf82bcda.png";